export default {
	sec_01: {
		title: {
			one: 'Pay With',
			two: 'JP WORLD',
			three: 'Pay',
		},
		desc: {
			one: 'Add the cryptocurrency you want and',
			two: 'experience shopping flexibly wherever you want.',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_02: {
		title: {
			one: 'cryptocurrency that is only in your electronic wallet JP WORLD Pay through',
			two: 'Enjoy shopping anywhere with.',
		},
		step: {
			one: {
				one: 'Make a cryptocurrency',
				two: 'wallet that you want in',
				three: 'JP WORLD Pay',
			},
			two: {
				one: 'Please choose',
				two: 'JP WORLD Pay',
				three: 'when you are shopping',
			},
			three: {
				one: 'Pay with the cryptocurrency',
				two: 'you want on',
				three: 'JP WORLD Pay',
			},
		},
	},
	sec_03: {
		title: {
			one: 'We hope you enjoy it again',
		},
		desc: {
			one: 'Please buy with ',
			two: 'JP WORLD Pay,',
			three: 'get points and then buy again.',
			four: 'JPWORLDPAY points are available',
			five: 'at all Merchants using',
			six: 'JP WORLD Pay.',
		},
	},
	sec_04: {
		title: {
			one: 'Pay without worrying.',
		},
		desc: {
			one: "JP WORLD Pay's",
			two: 'security is the best in the world.',
			three: 'We keep your cryptocurrency and assets safe and',
			four: 'help you use them safely.',
		},
	},
};
